import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
// Actions
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { getUI } from 'redux/selectors';
import * as UserActions from 'redux/actions/user';
import * as InvitationActions from 'redux/actions/invitation';

// Components
import Dialog from '@material-ui/core/Dialog';

import { USER_SHARING_STATUS } from 'common/constant';

const EnableSharingConfirmationDialog = ({ close, invitationId, open }) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const _close = useCallback(() => {
        if (close) {
            close();
        }
    }, [close]);

    const _done = useCallback(
        (e) => {
            dispatch(
                UserActions.update(
                    {
                        sharing: true
                    },
                    USER_SHARING_STATUS
                )
            ).then((response) => {
                dispatch(
                    InvitationActions.update(
                        {
                            accept_status: true
                        },
                        invitationId
                    )
                ).then((response) => {
                    history.push(`/app/invitation/${invitationId}`);
                    _close();
                });
            });
        },
        [_close, dispatch, history, invitationId]
    );

    return (
        <Dialog
            fullWidth={true}
            open={open}
            onClose={_close}
            aria-labelledby="form-dialog-title">
            <div
                id="delete-modal"
                className="modal-box modal-box--delete modal-box--500">
                <div className="delete-modal">
                    <div className="delete-modal__content">
                        <div className="delete-modal__title">
                            If you accept an invitation, sharing will be enabled
                            by default.
                        </div>
                    </div>
                    <div className="delete-modal__actions">
                        <button className="btn btn-outline" onClick={_close}>
                            Cancel
                        </button>
                        <button className="btn btn-delete" onClick={_done}>
                            Accept
                        </button>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

const state = createStructuredSelector({
    ui: getUI
});

export default connect(state)(EnableSharingConfirmationDialog);
